import type { GameState, SimEvent } from '../types.js';

/** Distributive Omit so unions stay unions. */
type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never;

export type EventInput = DistributiveOmit<SimEvent, 'tick'>;

/** Push a simulation event; the host drains state.events after each step. */
export function emit(state: GameState, ev: EventInput): void {
  state.events.push({ ...ev, tick: state.tick } as SimEvent);
}

export function drainEvents(state: GameState): SimEvent[] {
  const out = state.events;
  state.events = [];
  return out;
}
